/* eslint-disable max-len */
import  React, {useContext}  from 'react'
import Pagination from '../../../../../components/Pagination'
import { useNavigate } from 'react-router-dom'
import { formatAdjustedDate } from '../../../../../CommonMethods/formatDate'
import GlobalContext from '../../../../../components/Context/GloablContext';

const Table = ({inwardTransferStudentList,
    searchParams, 
    setSearchParams,  
    setPageLoading, 
    inwardTransferStudentCount}) => {
    const navigation = useNavigate()
    const { isInactiveBranch } = useContext(GlobalContext)
    /**
     * The function `handleOnClickPageNumber` updates the search parameters with a new page number and sets
     * the page loading state to true.
     */
    const handleOnClickPageNumber = (pageNum) => {
        setPageLoading(true);
        const params = Object.fromEntries(searchParams)
        setSearchParams({ ...params, page_number: pageNum.selected + 1 })
    }

    // Utility function to find the text with the maximum length
    const findMaxTextLength = (texts) => {
        return texts.reduce((maxText, currentText) => (currentText?.length > maxText?.length ? currentText : maxText), '');
    };
  
    // Utility function to calculate dynamic height based on text length
    const calculateDynamicHeight = (texts, baseHeight = 40, increasePerCharacter = 20) => {
        const maxText = findMaxTextLength(texts);
        const additionalHeight = Math.ceil(maxText?.length / 10) * increasePerCharacter;
        return `${baseHeight + additionalHeight}px`;
    };  

    const noSearchOrFilter = searchParams.get('search') === null && searchParams.get('filter') === null;

    return(
        <div class="-mx-1">
            <div class="overflow-auto pb-[62px] scroll-bar pl-1">
                <div class="flex mb-1 w-full" data-testid="promote-table" style={{'display':'inline-block'}}>
                    <table aria-label="Outside Table" class="w-full  mt-1 auto-layout" id="admin-table">
                        <thead>
                            <tr>
                                <th class="min-w-[130px]">
                                    <span >Student ID
                                    </span>
                                </th>
                                <th class="min-w-[175px]">
                                    <span >Student Name
                                    </span>
                                </th>
                                <th class="min-w-[170px]">
                                    <span >Transferred from
                                    </span>
                                </th>
                                <th class="min-w-[120px]">
                                    <span >Transfer ID
                                    </span>
                                </th>
                                <th class="min-w-[110px]">
                                    <span >Status
                                    </span>
                                </th>
                                <th class="min-w-[140px]">
                                    <span >Initiated on
                                    </span>
                                </th>
                                <th class="min-w-[170px]">
                                    <span >Initiated by
                                    </span>
                                </th>
                                <th class="min-w-[150px]">    
                                    <span >Processed Date
                                    </span>
                                </th>
                                <th class="min-w-[170px]">
                                    <span >Processed by
                                    </span>
                                </th>
                                <th class="min-w-[230px] sticky-right">
                                    <span class="flex items-center justify-center">Action
                                    </span>
                                </th>
                            </tr>
                            <tr aria-colspan="7" class="h-1"></tr>
                        </thead>
                        <tbody >
                            {inwardTransferStudentList?.map((inward, index) => (
                                <>
                                    <tr id="list-items" aria-colspan="7" class="relative h-0.5 z-[-10]"></tr>
                                    <tr class="group">
                                        <td class="text-start">{inward?.transferred_student_id || '-'}</td>
                                        <td class="text-start ">{inward?.student_name}</td>
                                        <td class="text-start ">{inward?.transferred_from}</td>

                                        <td class="text-start">{inward?.transfer_id}</td>
                                        <td class="text-start  capitalize">{inward?.status}</td>
                                        <td class="text-start">{formatAdjustedDate(inward?.transferred_on)}</td>

                                        <td class="text-start">{inward?.transferred_by}</td>
                                        <td class="text-start">{inward?.processed_on !== undefined ?formatAdjustedDate(inward?.processed_on) : '-'}</td>
                                        <td class="text-start">{inward?.processed_by || '-'}</td>

                                        <td class="min-w-[230px] sticky-right">
                                            {/* <div className='w-[20px] h-[14px] z-[-1] bg-white absolute top-[-2px] left-[214px] '></div> */}
                                            <div className='flex justify-center items-center z-[10]'>
                                                {inward?.status?.toLowerCase() === 'pending' ? <button
                                                    id='process_tranfer'
                                                    className='list-actn-btn'
                                                    disabled={isInactiveBranch}
                                                    onClick={() => navigation(`/student-master/transfers/process-transfer/${inward?.transfer_id}`)}
                                                >
                                                    Process Transfer
                                                </button> : <button id='Processed' disabled='true' className='list-actn-btn'>Processed</button>}
                                            </div>
                                        </td>
                                        {/* <div className='z-[10]'>
                                                {inward?.status === 'completed' ? <button className='flex justify-center z-[10] items-center pl-[1.125rem] pr-[1.125rem] p-2 h-[2.6875rem] rounded-lg border border-[#106eb4] text-[#106eb4] text-lg font-medium leading-7 ml-[10px]'  >
                                                    Process Transfer
                                                </button> : <p></p>}
                                            </div> */}
                                    </tr>
                                </>))}
                        </tbody>
                        {inwardTransferStudentCount === 0 && (
                            <tbody>
                                <tr>
                                    <td id="no-matching-result" style={{ 'line-height': '100px', 'text-align': 'center'}} colspan="14" className="shadow-s13 no-records-message">
                                        {noSearchOrFilter ? `No incoming transfers found` : 'No matching records found.'}
                                    </td>
                                </tr>
                            </tbody>
                        )}
                    </table>
                </div>
            </div>
            {inwardTransferStudentCount > 10 &&  <Pagination
                TotalCount={inwardTransferStudentCount}
                totalPageNumber={Math?.ceil(inwardTransferStudentCount / 10)}
                selectedPageNumber={Number(searchParams.get('page_number')) || 1}
                handleOnClickPageNumber={handleOnClickPageNumber}
            />}
        </div>
    )
}
export default Table;   